module.exports = __webpack_public_path__ + "img/dashuju-2.a04ad742.png";